export const config = {
  fields: {
    card: {
      selector: '#cc-card'
    },
    cvv: {
      selector: '#cc-cvv'
    },
    exp: {
      selector: '#cc-exp'
    },
    name: {
      selector: '#cc-name',
      placeholder: 'Full Name'
    }
  },

  // css classes to be injected into the iframes.
  // the properties allowed are restricted via whitelist.
  // further, unrestricted styling can be applied to the div's in which the iframes are injected.
  styles: {
    input: {
      'font-size': '16px',
      color: '#00a9e0',
      'font-family': 'monospace',
      background: 'black'
    },
    '.card': {
      'font-family': 'monospace'
    },
    ':focus': {
      color: '#00a9e0'
    },
    '.valid': {
      color: '#43B02A'
    },
    '.invalid': {
      color: '#C01324'
    },
    '@media screen and (max-width: 700px)': {
      input: {
        'font-size': '18px'
      }
    },
    'input:-webkit-autofill': {
      '-webkit-box-shadow': '0 0 0 50px white inset'
    },
    'input:focus:-webkit-autofill': {
      '-webkit-text-fill-color': '#00a9e0'
    },
    'input.valid:-webkit-autofill': {
      '-webkit-text-fill-color': '#43B02A'
    },
    'input.invalid:-webkit-autofill': {
      '-webkit-text-fill-color': '#C01324'
    },
    'input::placeholder': {
      color: '#aaa'
    }
  },

  // these values correspond to css class names defined above
  classes: {
    empty: 'empty',
    focus: 'focus',
    invalid: 'invalid',
    valid: 'valid'
  }
}
